import { render, staticRenderFns } from "./ResizeAreaVcDemo.vue?vue&type=template&id=017c1351&scoped=true&"
import script from "./ResizeAreaVcDemo.vue?vue&type=script&lang=js&"
export * from "./ResizeAreaVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./ResizeAreaVcDemo.vue?vue&type=style&index=0&id=017c1351&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017c1351",
  null
  
)

export default component.exports